import type { JSX } from "react";

import ArrowRight from "@repo/icons/default/ArrowRight";
import { CpsButtonText, CpsInput } from "corpus";

import { Button } from "@/components/ui/button/button";
import { SelectInput } from "@/components/ui/input/select-input";
import {
  CardSelectDescription,
  CardSelectTitle,
} from "@/components/ui/select-input/card-select.tsx";

const COUNCIL_NUMBER_MAX_LENGTH = 10;

interface ProfessionWithCouncilSubStepProps {
  councilNumber: string;
  onCouncilNumberChange: (value: string) => void;
  councilName: string;
  uf: string;
  onUfChange: (value: string) => void;
  ufOptions: { label: string; value: string }[];
  title: string;
  description?: string;
  buttonText: string;
  skipButtonText: string;
  isLoading?: boolean;
  onSubmit: () => void | Promise<void>;
  onSkip: () => void | Promise<void>;
}

export const ProfessionWithCouncilSubStep = ({
  councilNumber,
  onCouncilNumberChange,
  councilName,
  uf,
  onUfChange,
  ufOptions,
  title,
  description,
  buttonText,
  skipButtonText,
  isLoading,
  onSubmit,
  onSkip,
}: ProfessionWithCouncilSubStepProps): JSX.Element => {
  const isCouncilValid = councilNumber.trim().length > 0 && uf.length > 0;

  return (
    <div className="flex flex-col gap-4 h-full justify-between">
      <div className="flex flex-col gap-6 pb-6">
        <div>
          <CardSelectTitle>{title}</CardSelectTitle>
          {description ? (
            <CardSelectDescription>{description}</CardSelectDescription>
          ) : null}
        </div>

        <CpsInput
          title={`Número do ${councilName}`}
          placeholder="Ex: 123456"
          value={councilNumber}
          maxLength={COUNCIL_NUMBER_MAX_LENGTH}
          onChange={(e) => {
            onCouncilNumberChange(e.target.value);
          }}
        />

        <SelectInput<string>
          name="uf"
          title={`Estado do ${councilName} (UF)`}
          items={ufOptions}
          value={uf}
          defaultValue="SP"
          onChange={(val) => {
            onUfChange(val as string);
          }}
        />
      </div>

      <div className="flex flex-col gap-4 sticky bottom-0 self-end bg-white w-full">
        <Button
          loading={isLoading}
          fullWidth
          onClick={() => {
            void onSubmit();
          }}
          disabled={!isCouncilValid}
        >
          <div className="flex flex-row gap-2 items-center">
            {buttonText}
            <ArrowRight size={24} />
          </div>
        </Button>
        <CpsButtonText
          className="text-neutral-500 font-medium"
          onClick={() => {
            void onSkip();
          }}
        >
          {skipButtonText}
        </CpsButtonText>
      </div>
    </div>
  );
};
